export enum PlainTextItemConditionRule {
	EQUAL = 'EQUAL',
	NOT_EQUAL = 'NOT_EQUAL',
	FILLED = 'FILLED',
}
